import React from "react";
import PropTypes from "prop-types";
import {
  Alert,
  Autocomplete,
  Box,
  Button,
  CircularProgress,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { isValidPlate, plateCommerceId } from "../../model/plateModel";
export default function HeaderPlacas({ state }) {
  const selected =
    state.comercios.find((item) => item.idcommerce === plateCommerceId(state.filtros.idCommerce)) ||
    null;
  const valid = Boolean(selected && isValidPlate(state.filtros.placa));
  return (
    <Box
      component="form"
      onSubmit={(event) => {
        event.preventDefault();
        if (valid) state.consultarPlaca(selected.idcommerce, state.filtros.placa);
      }}
      sx={{
        "& .MuiOutlinedInput-root": { minHeight: 52, bgcolor: "#fff", borderRadius: 2 },
        "& .MuiOutlinedInput-notchedOutline": { borderColor: "#91a6b8" },
        "& .MuiInputBase-input": { fontSize: ".95rem", color: "#183b50" },
        "& .MuiInputLabel-root": { color: "#405972", fontWeight: 600 },
      }}
    >
      <Typography sx={{ fontSize: "1rem", fontWeight: 700, color: "#183b50", mb: 0.5 }}>
        Consultar placa por comercio
      </Typography>
      <Typography sx={{ fontSize: ".8rem", color: "#526579", mb: 2 }}>
        Consulte los estados reportados por Cerberus y Poseidon para el comercio seleccionado.
      </Typography>
      {state.commerceError && (
        <Alert
          severity="error"
          sx={{ mb: 2 }}
          action={
            <Button onClick={state.loadComercios} disabled={state.loadingComercios}>
              Reintentar
            </Button>
          }
        >
          {state.commerceError}
        </Alert>
      )}
      <Grid container spacing={2} alignItems="flex-start">
        <Grid item xs={12} md={7}>
          <Autocomplete
            options={state.comercios}
            value={selected}
            disabled={state.loadingComercios}
            loading={state.loadingComercios}
            getOptionLabel={(item) => `${item.namecomercio} · ${item.idcommerce}`}
            isOptionEqualToValue={(a, b) => a.idcommerce === b.idcommerce}
            onChange={(_, item) => state.setFiltro("idCommerce", item?.idcommerce ?? "")}
            loadingText="Cargando comercios..."
            noOptionsText="No se encontraron comercios"
            renderInput={(params) => (
              <TextField
                {...params}
                label="Comercio"
                required
                InputLabelProps={{ shrink: true }}
                placeholder="Seleccione un comercio"
              />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={7} md={3}>
          <TextField
            fullWidth
            label="Placa"
            name="placa"
            required
            placeholder="ABC123 o ABC12A"
            value={state.filtros.placa}
            onChange={(event) => state.setFiltro("placa", event.target.value)}
            InputLabelProps={{ shrink: true }}
            inputProps={{ maxLength: 8 }}
            helperText={
              state.filtros.placa && !isValidPlate(state.filtros.placa)
                ? "Use ABC123 para carro o ABC12A para moto"
                : "Carro o moto"
            }
            error={Boolean(state.filtros.placa && !isValidPlate(state.filtros.placa))}
          />
        </Grid>
        <Grid item xs={12} sm={5} md={2}>
          <Button
            type="submit"
            variant="contained"
            fullWidth
            disabled={!valid || state.loading}
            startIcon={
              state.loading ? <CircularProgress size={18} color="inherit" /> : <SearchIcon />
            }
            sx={{
              minHeight: 52,
              bgcolor: "#185a75",
              color: "#fff",
              "&:hover": { bgcolor: "#103f54" },
            }}
          >
            {state.loading ? "Consultando..." : "Consultar"}
          </Button>
        </Grid>
      </Grid>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mt: 1,
          gap: 1,
          flexWrap: "wrap",
        }}
      >
        <Typography sx={{ fontSize: ".75rem", color: "#526579" }}>
          Cambiar la placa o el comercio descarta la consulta anterior.
        </Typography>
        <Button onClick={state.clearFilters} size="small" sx={{ color: "#185a75" }}>
          Limpiar consulta
        </Button>
      </Box>
    </Box>
  );
}
HeaderPlacas.propTypes = { state: PropTypes.object.isRequired };
